import Phaser from "phaser";
import { GAME_WIDTH, GAME_HEIGHT } from "../config";
import { PurchaseGate } from "../systems/PurchaseGate";

/** メニューシーン */
export class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: "MenuScene" });
  }

  create(): void {
    // タイトル
    const title = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT * 0.25, "TEXT INVADERS", {
      fontSize: "36px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#00ffcc",
      fontStyle: "bold",
    });
    title.setOrigin(0.5, 0.5);

    // サブタイトル
    const subtitle = this.add.text(
      GAME_WIDTH / 2,
      GAME_HEIGHT * 0.33,
      "読めるのに間に合わない",
      {
        fontSize: "16px",
        fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
        color: "#aaaaaa",
      }
    );
    subtitle.setOrigin(0.5, 0.5);

    // Startボタン
    const startBtn = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT * 0.55, "START", {
      fontSize: "28px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#ffffff",
      backgroundColor: "#333333",
      padding: { x: 40, y: 16 },
    });
    startBtn.setOrigin(0.5, 0.5);
    startBtn.setInteractive({ useHandCursor: true });
    startBtn.on("pointerover", () => startBtn.setColor("#00ffcc"));
    startBtn.on("pointerout", () => startBtn.setColor("#ffffff"));
    startBtn.on("pointerdown", () => {
      this.scene.start("PlayScene");
    });

    // 長文モード解放バッジ
    const gate = new PurchaseGate();
    if (gate.getFlag() === "LONG_MODE") {
      const badge = this.add.text(
        GAME_WIDTH / 2,
        GAME_HEIGHT * 0.68,
        "長文モード解放済",
        {
          fontSize: "14px",
          fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
          color: "#ffdd44",
        }
      );
      badge.setOrigin(0.5, 0.5);
    }
  }
}
